import { render, staticRenderFns } from "./MenuItemDisplay.vue?vue&type=template&id=2927a5f2&scoped=true&"
import script from "./MenuItemDisplay.vue?vue&type=script&lang=js&"
export * from "./MenuItemDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemDisplay.vue?vue&type=style&index=0&id=2927a5f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2927a5f2",
  null
  
)

export default component.exports